var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 89,
    viewBox: "0 0 60 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.6544 73.27V83H22.0584V76.336L19.0904 83H17.9844L15.0024 76.336V83H13.4064V73.27H15.1284L18.5444 80.9L21.9464 73.27H23.6544ZM29.0981 83.126C28.3701 83.126 27.7121 82.9627 27.1241 82.636C26.5361 82.3 26.0741 81.8333 25.7381 81.236C25.4021 80.6293 25.2341 79.9293 25.2341 79.136C25.2341 78.352 25.4068 77.6567 25.7521 77.05C26.0975 76.4433 26.5688 75.9767 27.1661 75.65C27.7635 75.3233 28.4308 75.16 29.1681 75.16C29.9055 75.16 30.5728 75.3233 31.1701 75.65C31.7675 75.9767 32.2388 76.4433 32.5841 77.05C32.9295 77.6567 33.1021 78.352 33.1021 79.136C33.1021 79.92 32.9248 80.6153 32.5701 81.222C32.2155 81.8287 31.7301 82.3 31.1141 82.636C30.5075 82.9627 29.8355 83.126 29.0981 83.126ZM29.0981 81.74C29.5088 81.74 29.8915 81.642 30.2461 81.446C30.6101 81.25 30.9041 80.956 31.1281 80.564C31.3521 80.172 31.4641 79.696 31.4641 79.136C31.4641 78.576 31.3568 78.1047 31.1421 77.722C30.9275 77.33 30.6428 77.036 30.2881 76.84C29.9335 76.644 29.5508 76.546 29.1401 76.546C28.7295 76.546 28.3468 76.644 27.9921 76.84C27.6468 77.036 27.3715 77.33 27.1661 77.722C26.9608 78.1047 26.8581 78.576 26.8581 79.136C26.8581 79.9667 27.0681 80.6107 27.4881 81.068C27.9175 81.516 28.4541 81.74 29.0981 81.74ZM36.2759 76.406C36.5092 76.014 36.8172 75.7107 37.1999 75.496C37.5919 75.272 38.0539 75.16 38.5859 75.16V76.812H38.1799C37.5545 76.812 37.0785 76.9707 36.7519 77.288C36.4345 77.6053 36.2759 78.156 36.2759 78.94V83H34.6799V75.286H36.2759V76.406ZM47.1229 78.954C47.1229 79.2433 47.1043 79.5047 47.0669 79.738H41.1729C41.2196 80.354 41.4483 80.8487 41.8589 81.222C42.2696 81.5953 42.7736 81.782 43.3709 81.782C44.2296 81.782 44.8363 81.4227 45.1909 80.704H46.9129C46.6796 81.4133 46.2549 81.9967 45.6389 82.454C45.0323 82.902 44.2763 83.126 43.3709 83.126C42.6336 83.126 41.9709 82.9627 41.3829 82.636C40.8043 82.3 40.3469 81.8333 40.0109 81.236C39.6843 80.6293 39.5209 79.9293 39.5209 79.136C39.5209 78.3427 39.6796 77.6473 39.9969 77.05C40.3236 76.4433 40.7763 75.9767 41.3549 75.65C41.9429 75.3233 42.6149 75.16 43.3709 75.16C44.0989 75.16 44.7476 75.3187 45.3169 75.636C45.8863 75.9533 46.3296 76.4013 46.6469 76.98C46.9643 77.5493 47.1229 78.2073 47.1229 78.954ZM45.4569 78.45C45.4476 77.862 45.2376 77.3907 44.8269 77.036C44.4163 76.6813 43.9076 76.504 43.3009 76.504C42.7503 76.504 42.2789 76.6813 41.8869 77.036C41.4949 77.3813 41.2616 77.8527 41.1869 78.45H45.4569Z",
    fill: "#F4F3FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_608_8457)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#CAE9FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 19.25C21.8244 19.25 19.25 21.8244 19.25 25V35C19.25 38.1756 21.8244 40.75 25 40.75H35C38.1756 40.75 40.75 38.1756 40.75 35V25C40.75 21.8244 38.1756 19.25 35 19.25H25ZM33.75 30C33.75 30.4142 33.4142 30.75 33 30.75H30.75V33C30.75 33.4142 30.4142 33.75 30 33.75C29.5858 33.75 29.25 33.4142 29.25 33V30.75H27C26.5858 30.75 26.25 30.4142 26.25 30C26.25 29.5858 26.5858 29.25 27 29.25H29.25V27C29.25 26.5858 29.5858 26.25 30 26.25C30.4142 26.25 30.75 26.5858 30.75 27V29.25H33C33.4142 29.25 33.75 29.5858 33.75 30Z",
    fill: "#2A2A2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_608_8457",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_608_8457"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_608_8457"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleGame);
export default __webpack_public_path__ + "static/media/Title Game.6a5ab6201e7b3302bbcac78c68311048.svg";
export { ForwardRef as ReactComponent };